import { ReactNode } from 'react';

const FormGroup = ({ children }: { children: ReactNode }): JSX.Element => {
  return <div className="space-y-1.5">{children}</div>;
};

export default FormGroup;
